/**
 * Class names for `ErrorBoundary` components (src/components/ErrorBoundary/).
 */
export const errorBoundaryClassNames = {
  defaultErrorFallbackRoot: "error-boundary__default-error-fallback-root",
} as const;
